module.exports = __webpack_public_path__ + "static/media/videos.bf96c39d.svg";